import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, of, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { SharedService } from '../../services/shared.service';
import { environment } from '../../../environments/environment';
import { TokenStorageService } from 'src/app/services/token-storage.service';

interface RefreshResponse {
  StatusCode?: number;
  Error?: string | null;
  Message?: string | null;
  Status: boolean;
  Data?: {
    AccessToken: string;
    RefreshToken?: string;
  };
}
@Injectable({
  providedIn: 'root',
})
export class AuthService {


  constructor(
    private http: HttpClient,
    private sharedService: SharedService,
    private tokenStore: TokenStorageService
  ) { }

  private apiUrl = this.sharedService.getUrl;
  private refreshUrl = `${environment.masterBaseUrl?.replace(/\/+$/, '')}/User/RefreshThirdPartyToken`;

  private _isRefreshing = false;
  private _tokenSubject = new BehaviorSubject<string | null>(null);


  ResetPassword(body: any): Observable<any> {
    return this.http.post(`${this.apiUrl}User/ResetPassword`, body);
  }

  TestEmailLinkExpiration(body: any, userId: string): Observable<any> {
    return this.http.post(
      `${this.apiUrl}User/TestEmailLinkExpiration?userId=${userId}`,
      body
    );
  }

  ForgetPassword(body: any, email: string): Observable<any> {
    return this.http.post(
      `${this.apiUrl}User/SendResetPasswordLink?email=${email}`,
      body
    );
  }

  GetUserDetails(id: number): Observable<any> {
    return this.http.get(`${this.apiUrl}User/GetUSERDetails?userId=${id}`);
  }

  autoLoginLocal(): Observable<boolean> {
    if (environment.bypassAuth && environment.staticAuth?.token) {
      const s = environment.staticAuth;
      localStorage.setItem('token', s.token);
      localStorage.setItem('userid', String(s.UserID));
      localStorage.setItem('fullName', s.UserName);
      localStorage.setItem('role', JSON.stringify({ name: 'Developer', roleId: 0 }));
      localStorage.setItem('branch', JSON.stringify({ branchId: 0, branchName: 'Local Dev' }));
      return of(true);
    }
    return of(false);
  }

  refreshToken(refreshToken: string): Observable<{ accessToken: string; refreshToken?: string }> {
    this._isRefreshing = true;
    this._tokenSubject.next(null);

    const body = { RefreshToken: refreshToken };

    return this.http.post<RefreshResponse>(this.refreshUrl, body).pipe(
      map((res) => {
        if (!res?.Status || !res?.Data?.AccessToken) {
          throw new Error(res?.Message || res?.Error || 'Invalid refresh response');
        }

        this.tokenStore.ssoAccessTokenSet(res.Data.AccessToken);
        if (res.Data.RefreshToken) {
          this.tokenStore.ssoRefreshTokenSet(res.Data.RefreshToken);
        }

        this._tokenSubject.next(res.Data.AccessToken);

        return {
          accessToken: res.Data.AccessToken,
          refreshToken: res.Data.RefreshToken,
        };
      }),
      tap(() => (this._isRefreshing = false)),
      catchError((err) => {
        console.error('[AuthService.refreshToken] Error:', err);
        this._isRefreshing = false;
        this.tokenStore.signOut();
        return throwError(() => err);
      })
    );
  }

  getRefreshState() {
    return {
      isRefreshing: this._isRefreshing,
      tokenSubject: this._tokenSubject.asObservable(),
    };
  }
}
